import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const featureFlags = {
  OCA_SUBMITTED: true,
  PLATE_TRANSFER: false,
  PLATE_TRANSFER_NEW_UI: true,
  SIMULATE_PAYMENTS: true,
  NEW_VEHICLE: true,
  SHARE_OCA: true,
  LOG: true,
  CHAT: true,
  MSD: true,
  SIGNAL: true,
  SECURITYDEPOSITE_UI : true,
  TOTALOFPAYMENTS_UI: true, //if true - Total Of Payments will be visible.
  CARS_DEALER_UI: true,
  DEALER_FUNDED: true,
  TRADE_SIGNAL: true,
  TRADE_TAX_SAVINGS:true,
  PAYMENT_STREAM :true,
  PAYMENT_STREAM_FINANCE_CASH :false,
  QR_CODE:true,
  DAYS_TO_FIRST: true,
  PREVIOUS_RENTAL: true,
  SET_DEALER_CASH: true,
  ISPRESOLD_ENABLED: true,
  RELEASE_NOTES: true,
  DUPLICATE_CASHDOWN: true,
  RESIDUAL_PERCENTAGE: true,
  CONFIGURABLE_PRICING_PDF: true,
  ENABLE_TFMV: true, // Texas Fair Market Value Deduction (TFMV)
  SECURITY_DEPOSIT: true,
  NEXUS_TOYOTA_DOMAIN: true,
}

const override = {
  production: API_ENDPOINTS.ISPRODUCTION.DEV,
  DESKING: API_ENDPOINTS.DESKING.DEV,
  hostname: API_ENDPOINTS.HOSTNAME.DEV,
  //AOT: AOT,
  ENV: API_ENDPOINTS.ENV.DEV, //(PROD || TEST || QA || E2E || STAGE) ? JSON.stringify('production') : JSON.stringify('development'), 
  /**
  * specifies which @ngrx dev tools will be available when you build and load
  * your app in dev mode. Options are: monitor | logger | both | none
  */
  STORE_DEV_TOOLS: API_ENDPOINTS.STORE_DEV_TOOLS.DEV,
  MIN_LOG_LEVEL: API_ENDPOINTS.MIN_LOG_LEVEL.DEV,
  ACTUAL_ENV: API_ENDPOINTS.ACTUAL_ENV.DEV,  //  PROD ? JSON.stringify('production') : QA ? JSON.stringify('qa') : TEST ? JSON.stringify('test') : E2E ? JSON.stringify('e2e') : STAGE ? JSON.stringify('stage') : JSON.stringify('development'),
  EFC_URL: API_ENDPOINTS.EFC_URL.DEV,
  AUTH_BASE_URL: API_ENDPOINTS.AUTH_BASE_URL.DEV,
  DIS_URL: API_ENDPOINTS.DIS_URL.DEV,
  BASE_SERVICE_URL: API_ENDPOINTS.BASE_SERVICE_URL.DEV,
  PRESOLD_BASE_SERVICE_URL: API_ENDPOINTS.PRESOLD_BASE_SERVICE_URL.DEV,
  USED_VEHICLE_BASE_SERVICE_URL: API_ENDPOINTS.USED_VEHICLE_BASE_SERVICE_URL.DEV,
  POST_LOGOUT_REDIRECT_URL: API_ENDPOINTS.POST_LOGOUT_REDIRECT_URL.DEV,
  SILENT_REDIRECT_URL: API_ENDPOINTS.SILENT_REDIRECT_URL.DEV,
  AUTHORIZATION_ENDPOINT: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.DEV,
  ISSUER: API_ENDPOINTS.ISSUER.DEV,
  JWTURI: API_ENDPOINTS.JWTURI.DEV,
  AUTHORITY: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.DEV,
  CLIENT_ID: API_ENDPOINTS.CLIENT_ID.DEV,
  CONSUMER_PREVIEW_ENDPOINT: API_ENDPOINTS.CONSUMER_PREVIEW_ENDPOINT.DEV,
  MST_BASE_SERVICE_URL: API_ENDPOINTS.MST_BASE_SERVICE_URL.DEV,
  DG_BASE_SERVICE_URL: API_ENDPOINTS.DG_BASE_SERVICE_URL.DEV,
  SOCKET_ENDPOINT: API_ENDPOINTS.SOCKET_ENDPOINT.DEV,
  VSPEC_GUEST_PORTAL: API_ENDPOINTS.VSPEC_GUEST_PORTAL.DEV,
  CREDIT_APP_URL: API_ENDPOINTS.CREDIT_APP_URL.DEV,
  ENGAGE_MATERIAL_URL: API_ENDPOINTS.ENGAGE_MATERIAL_URL.DEV,
  ENGAGE_MATERIAL_LEXUS_URL: API_ENDPOINTS.ENGAGE_MATERIAL_LEXUS_URL.DEV,
  MST_CONSOLE: API_ENDPOINTS.MST_CONSOLE.DEV,
  AUTH_AUTHORITY: API_ENDPOINTS.AUTH_AUTHORITY.DEV,
  FEATURE_FLAGS: featureFlags,
  SIGNAL_URL: API_ENDPOINTS.SIGNAL.DEV,
  TRADE_SIGNAL_URL: API_ENDPOINTS.TRADE_SIGNAL_ENDPOINT.DEV
};

export const environment = defaultsDeep(override, environmentDefaults);
